module.exports = __webpack_public_path__ + "media/images/mailers/cco_email/novem-Gold-113bc9b2ee3d481c6e6dda6d4d295521.png";